import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormContainerCaixaBanco } from '@/pages/movimentacoes/forms/FormContainerCaixaBanco';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

const SearchSchema = z.object({
    contaIdpk: z.number().int().positive(),
});

export const Route = createFileRoute('/a/movimentacoes/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    validateSearch: SearchSchema,
});

function Component() {
    const { action, idpk } = Route.useParams();
    const { contaIdpk } = Route.useSearch();

    return <FormContainerCaixaBanco action={action} contaIdpk={contaIdpk} idpk={idpk} />;
}
